/**
 * Alert_Rule creation (route `/alert-rules/new`; Feature: granular-crud-api, tasks 14.1, 14.2;
 * Requirements 11.4, 11.6, 11.7; Design: §11).
 *
 * `POST /v1/alert-rules` through {@link useWrite}: a failure keeps the draft and shows the returned
 * error — including the `undefined_check_reference` field error the API raises when a selector names a
 * Check that does not exist in the rule's Project (Req 5.2) — and a success returns to the rule list,
 * which re-reads it.
 */

import { useNavigate } from 'react-router-dom';

import { useApiClient } from '../api/use-api-client';
import { useCanWrite } from '../auth/use-can-write';
import { AlertRuleForm } from '../components/AlertRuleForm';
import { useWrite } from '../lib/use-write';

export function AlertRuleCreatePage(): JSX.Element {
  const client = useApiClient();
  const canWrite = useCanWrite();
  const navigate = useNavigate();
  const write = useWrite();

  return (
    <section>
      <h1>New alert rule</h1>
      {!canWrite ? (
        <p role="note" className="muted" data-testid="read-only-notice">
          Your role has read-only access, so alert rules cannot be created from the dashboard.
        </p>
      ) : (
        <AlertRuleForm
          mode="create"
          submitting={write.state.submitting}
          fieldErrors={write.state.fieldErrors}
          errorMessage={write.state.errorMessage}
          onSubmit={(payload) =>
            void write.run(
              () => client.createAlertRule(payload),
              () => navigate('/alert-rules'),
            )
          }
          onCancel={() => navigate('/alert-rules')}
        />
      )}
    </section>
  );
}
